const NAMESPACE = "navbar";

const KEYS = {
    testEnvironmentMessage: "testEnvironmentMessage",
    testEnvironmentActiveWarning: "testEnvironmentActiveWarning",
    supportTitle: "supportTitle",
    phoneLabel: "phoneLabel",
    emailLabel: "emailLabel"
};

const MESSAGES = {
    [KEYS.testEnvironmentMessage]: {
        value: "You are currently working in a test environment.",
        comment: "Message to tell the user they're working in a test environment"
    },
    [KEYS.testEnvironmentActiveWarning]: {
        value: "Test Environment active! Production changes are not recommended.",
        comment:
            "Warning displayed in production programs to discourage editing program design while there's an active test environment"
    },
    [KEYS.supportTitle]: {
        value: "Support",
        comment: "Title for support modal"
    },
    [KEYS.phoneLabel]: {
        value: "Phone:",
        comment: "Label for phone # field"
    },
    [KEYS.emailLabel]: {
        value: "Email:",
        comment: "Label for email field"
    }
};

export { KEYS, NAMESPACE, MESSAGES };
